import { Component } from '@angular/core';

@Component({
    selector: 'bulkUpdate',
    template: '<router-outlet></router-outlet>',
    standalone: false
})

export class BulkUpdateComponent {
}
